import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import LoadBoardService from "../app/data/load-board/loadBoardService";
import { LoadboardListManifestRequestParams } from "../app/data/load-board/models";
import { QUERY_KEYS } from "app/data/common/queryKeys";
const loadBoardService = LoadBoardService.getInstance();

export const useLoadboardManifestTrips = (params: LoadboardListManifestRequestParams) => {
    return useQuery({
        queryKey: [QUERY_KEYS.LOADBOARD_LIST, params],
        queryFn: async () => {
            // Create a clean object containing only defined values
            const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                    acc[key as keyof LoadboardListManifestRequestParams] = value;
                }
                return acc;
            }, {} as LoadboardListManifestRequestParams);

            const response = await loadBoardService.getManifestTrips(cleanParams);
            return response.data;
        },
        enabled: true,
    });
};

export const useCloseDoor = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: any) => {
            const response = await loadBoardService.closeDoor(payload);
            return response.data;
        },

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.LOADBOARD_LIST],
            });
        },
    });
};

export const useDispatchLoad = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: any) => {
            const response = await loadBoardService.dispatchLoad(payload);
            return response.data;
        },

        onSuccess: () => {
            // refresh loadboard data
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.LOADBOARD_LIST],
            });
        },
    });
};